import { callRequest } from '@/client/bridge'
import { OPEN_FORM, PDF_PAGE, PAGE_ACTION } from './constant'

/**
 * @description 获取猎豹浏览器版本
 * @return {string}
 */
export const clientGetLiebaoVersion = (function (window) {
  return window.chrome &&
  window.chrome.LiebaoGetVersion &&
  typeof window.chrome.LiebaoGetVersion === 'function'
    ? function () {
      return window.chrome.LiebaoGetVersion()
    }
    : function () {
      return '0'
    }
}(window))

/**
 * @description 获取客户端渠道号
 * @return{number}
 */
export const clientGetTryNo = (function (window) {
  // eslint-disable-next-line sonarjs/no-all-duplicated-branches
  return window.chrome &&
    window.chrome.GetTryNo &&
    typeof window.chrome.GetTryNo === 'function'
    ? function () {
      return window.chrome.GetTryNo() || 8011
    }
    : function () {
      return 8011
    }
}(window))

/**
 * @description 获取浏览器用户信息
 * @return {Object|null}
 */
export const clientGetUserInfo = function () {
  return callRequest({
    fn: 'user_info'
  })
}

/**
 * @description 登录
 * @return {null}
 */
export const clientLogin = function () {
  callRequest({
    fn: 'login_new'
  })
}

/**
 * @description VIP 弹框
 */
export const clientVipDialog = function () {
  callRequest({
    show_vip_rights: 9
  })
}

/**
 * pdf上报的埋点
 * @typedef {Object} ReportData
 * @property {OPEN_FORM} source 转换页打开来源
 * @property {PDF_PAGE} page_show 功能页
 * @property {PAGE_ACTION} click 页面点击行为
 */

/**
 * 调用客户端上报埋点节点
 * @param {String} table 表名
 * @param {ReportData} params 上报数据
 */
export const clientReport = (function (window) {
  return window.chrome &&
    window.chrome.reportnoformat &&
    typeof window.chrome.reportnoformat === 'function'
    // eslint-disable-next-line operator-linebreak
    ?
    /**
     * @param {String} table
     * @param {ReportData} params
     */
    function (table, params) {
      window.chrome.reportnoformat(table, JSON.stringify(params))
    }
    : function () {
      console.warn('非猎豹浏览器环境')
      // console.log('上报内容:', params)
    }
})(window)
